/*Import Estilo*/
import './index.scss';
import '../../css/global.css';
import '../../css/normalize.css';

/*Import Componentes*/
import Cabecalho from '../../components/Cabecalho';
import Rodape from '../../components/Rodape';

/*Import SEO*/
import { SEOHelmet } from '../../hooks/useSEO';

/*Import Bibliotecas*/
import { Link } from 'react-router-dom';

export default function NaoEncontrado() {
    const seoData = {
        title: 'Página Não Encontrada - Fracaro Store',
        description: 'A página que você está procurando não existe ou foi removida.',
        url: window.location.href,
    };

    return (
        <section className='container-principal-404'>
            <SEOHelmet {...seoData} />
            <Cabecalho />

            <main className='conteudo-404'>
                <div className='erro-container'>
                    <div className='erro-ilustracao'>
                        <span className='numero-404'>404</span>
                        <div className='icone-404'>
                            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="11" cy="11" r="8" stroke="#131C46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M21 21L16.65 16.65" stroke="#131C46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M8 11H14" stroke="#131C46" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                    </div>
                    <h1>Página não encontrada</h1>
                    <p>A página que você está procurando não existe, foi removida ou está temporariamente indisponível.</p>
                    <div className='erro-botoes'>
                        <Link to='/' className='btn-voltar-home'>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 12L12 3L21 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M5 10V20C5 20.5523 5.44772 21 6 21H9V15H15V21H18C18.5523 21 19 20.5523 19 20V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            Voltar ao Início
                        </Link>
                        <Link to='/produtos' className='btn-ver-produtos'>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M3 6H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            Ver Produtos
                        </Link>
                    </div>
                </div>
            </main>

            <Rodape />
        </section>
    );
}
